let obsMsgMap = {
  1: {
    name: 'CONST_EU_OBS_ADD_TASK_1',
    description: '添加任务'
  },
  2: {
    name: 'CONST_EU_OBS_ADD_TASK_ACK_2',
    description: '添加任务ACK'
  },
  3: {
    name: 'CONST_EU_OBS_UPDATE_TASK_3',
    description: '更新任务'
  },
  4: {
    name: 'CONST_EU_OBS_UPDATE_TASK_ACK_4',
    description: '更新任务ACK'
  },
  5: {
    name: 'CONST_EU_OBS_DEL_TASK_5',
    description: '删除任务'
  },
  6: {
    name: 'CONST_EU_OBS_DEL_TASK_ACK_6',
    description: '删除任务ACK'
  },
  7: {
    name: 'CONST_EU_OBS_CHECK_TASK_7',
    description: '检查任务'
  },
  8: {
    name: 'CONST_EU_OBS_CHECK_TASK_ACK_8',
    description: '检查任务ACK'
  },
  9: {
    name: 'CONST_EU_OBS_UPDATE_TASK_STATUS_9',
    description: '检查任务'
  },
  10: {
    name: 'CONST_EU_OBS_UPDATE_TASK_STATUS_ACK_10',
    description: '检查任务ACK'
  },
  11: {
    name: 'CONST_EU_OBS_FUNCTION_END_11',
    description: ''
  },
}
export default {

  showOBSMessageName: (msgfunc) => {
    let data = obsMsgMap(msgfunc)
    if (data)
      return data.name
    else
      return data.toString()
  }

}